<!--
  The km-tooltip-portal component is use to drive a single v-tooltip, globally for the whole app.
  See the km-tooltip component for extra documentation.
-->
<template>
  <VTooltip
    tag="div"
    v-bind="attrs"
    class="km-tooltip-portal-component"
    :contentClass="contentClass"
    :activator="activator"
    :value="show"
    :zIndex="1000"
  >
    <Vnodes :vnodes="content" />
  </VTooltip>
</template>

<script>
import { listen } from './controller'

export default {
  name: 'KmTooltipPortal',

  components: {
    Vnodes: {
      functional: true,
      render: (h, ctx) => ctx.props.vnodes,
    },
  },

  data() {
    return {
      activator: null,
      content: null,
      attrs: {},
      color: 'contrast',
      show: false,
    }
  },

  computed: {
    contentClass() {
      const colorClass = this.color === 'base' ? 'km-tooltip-base' : 'km-tooltip-contrast'
      return `km-tooltip-content ${colorClass}`
    },
  },

  mounted() {
    this.unlisten = listen(this.onChange)
  },

  destroyed() {
    this.unlisten()
  },

  methods: {
    onChange(event) {
      if (event === false) {
        this.show = false
      } else {
        this.show = true
        this.content = event.content
        this.activator = event.activator
        const { color, ...attrs } = event.attrs
        this.attrs = attrs
        this.color = color
      }
    },
  },
}
</script>

<style lang="postcss">
.km-tooltip-content {
  font-size: 1rem;
  pointer-events: none;
}

/* When not transitioning OR for the transition enter target */
.km-tooltip-content:not([class*='-transition']),
.km-tooltip-content[class*='-transition-enter-to'] {
  opacity: 1 !important;
}

.km-tooltip-base {
  background-color: var(--base) !important;
}

.km-tooltip-contrast {
  background-color: var(--contrast) !important;
}
</style>
